import { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import { Box, Grid, Switch, Typography } from 'src/components/UI'
import EditablePanel from 'src/components/UI/CustomUI/molecules/EditablePanel'
import Table from 'src/components/UI/CustomUI/organisms/Table'
import { getClient, getClientInfo, getClientProperties, getPriceModelAffiliate, getPriceModelNar } from 'src/ducks/selectors'
import { PropertyDetail } from 'src/ducks/types'
import { formatTimestamp } from 'src/helpers'
import headers from './headers'
import { useDispatch } from 'react-redux'
import { clientActions } from 'src/ducks/actions'
import { toast } from 'react-toastify'

export interface ProfileProps {
    openModal: () => void
}

const Profile: FC<ProfileProps> = ({
    openModal
}) => {
    const narPrice = useSelector(getPriceModelNar)
    const affiliatePrice = useSelector(getPriceModelAffiliate)
    const narData = useSelector(getClientInfo(narPrice, affiliatePrice))
    const client = useSelector(getClient())
    const properties = useSelector(getClientProperties) as PropertyDetail[]

    const dispatch = useDispatch()
    const [registrationLoading, setRegistrationLoading] = useState(false)

    const handleRegistrationCompletedChange = (checked: boolean) => {
        setRegistrationLoading(true)
        dispatch(clientActions.updateClientId(
            client.id,
            { registrationCompleteOn: checked ? Date.now() : 0 },
            (succ: boolean) => {
                setRegistrationLoading(false)
                if (succ) {
                    toast.success(checked
                        ? 'Registration marked as completed'
                        : 'Registration marked as not completed')
                } else {
                    toast.error('Failed to update registration status')
                }
            },
        ))
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
                <Box>
                    <Typography variant="h5" fontFamily="var(--font-medium)" marginBottom={2}>
                        Dates
                    </Typography>
                    <Typography variant="h6" color="GrayText">
                        Created Date:
                    </Typography>
                    <Typography variant="body1" marginBottom={2}>
                        {client.insertedOn ? formatTimestamp(client.insertedOn, 'MM/DD/YYYY') : '-'}
                    </Typography>

                    <Grid container spacing={1} alignItems="center" marginBottom={2}>
                        <Grid item xs={4}>
                            <Typography variant="h6" color="GrayText">
                                Registration Completed:
                            </Typography>
                            <Typography variant="body1">
                                {client.registrationCompleteOn
                                    ? formatTimestamp(client.registrationCompleteOn, 'MM/DD/YYYY')
                                    : 'NO'}
                            </Typography>
                        </Grid>
                        <Grid item xs={2} alignSelf="end">
                            <Switch
                                checked={!!client.registrationCompleteOn}
                                disabled={registrationLoading}
                                onChange={(_, checked) => handleRegistrationCompletedChange(checked)}
                                inputProps={{ 'aria-label': 'Registration completed' }}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box marginTop={3}>
                    <Grid container justifyContent="space-between" alignItems="center" marginBottom={2}>
                        <Typography variant="h5" fontFamily="var(--font-medium)">
                            Affiliate Information
                        </Typography>
                    </Grid>
                    <EditablePanel data={narData} openModal={openModal} />
                </Box>
            </Grid>

            <Grid item xs={12} md={8}>
                <Typography variant='h5' fontFamily="var(--font-medium)" marginBottom={2}>
                    Customer Properties
                </Typography>
                <Table headers={headers} hasPagination={false}>
                    {properties?.map(property => ({
                        ...property,
                    }))}
                </Table>
            </Grid>
        </Grid>
    )
}

export default Profile